import { Box, ListSubheader, useTheme } from '@mui/material';

import { Dimens } from '~themes';

import { SideMenuItemType, SideMenuSection } from '../types';
import DropdownGroup from './dropdownGroup';
import { MenuLi, MenuSubList } from './menuPrimitives';
import PageRow from './pageRow';

interface Props {
	section: SideMenuSection;
	showLabel: boolean;
}

/** A non-clickable group header followed by its pages / dropdowns. */
const SectionGroup = ({ section, showLabel }: Props) => {
	const { typography, palette } = useTheme();

	return (
		<MenuLi block>
			{showLabel ?
				<ListSubheader
					component='div'
					disableSticky
					sx={{
						px: Dimens.spacingMd,
						pt: Dimens.spacingLg,
						pb: Dimens.spacingXs,
						backgroundColor: 'transparent',
						width: '100%',
						...typography.labelSm,
						color: palette.textQuaternary.main,
					}}
				>
					{section.title}
				</ListSubheader>
			:	<Box sx={{ width: '100%', height: Dimens.spacingMd }} />}
			<MenuSubList>
				{section.items.map((item) =>
					item.type === SideMenuItemType.Dropdown ?
						<DropdownGroup key={item.title} dropdown={item} showLabel={showLabel} />
					:	<PageRow key={item.label} page={item} showLabel={showLabel} />
				)}
			</MenuSubList>
		</MenuLi>
	);
};

export default SectionGroup;
